<div class="filter-bar">
<lib-emc-search-component [entityType]="entityType!" [cimClass]="cimClass" [substationTemplateId]="substationTemplateId" (searchOutput)="searchOutput($event)"></lib-emc-search-component>

  <div class="dropdown">
    <button (click)="toggleDropdown()" class="dropdown-button">
      {{ sortByName }}
      <img src="../../../assets/icons/ng_v3/dropdown-icon.svg" alt="dropdown icon" />
    </button>
    <div *ngIf="dropdownOpened" class="dropdown-options">
      <div class="dropdown-description">Date Type</div>
      <div (click)="selectSortByOption(sortByOptions.NEWEST)" class="dropdown-option">
        <span>Newest</span>
        <svg *ngIf="sortByValue === sortByOptions.NEWEST" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div> 
      <ng-container *ngIf="entityType !== EMCType.EquipmentTemplate">
        <div (click)="selectSortByOption(sortByOptions.SLRN_ASC)" class="dropdown-option">
          <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6569 5.96207L10.2394 7.373L6.9845 4.10273L6.9708 17.7078L4.9708 17.7058L4.9844 4.13793L1.75416 7.3531L0.343262 5.93559L6.0133 0.291992L11.6569 5.96207Z" fill="#000000"/>
          </svg>
          <span>SLRN</span>
          <svg *ngIf="sortByValue === sortByOptions.SLRN_ASC" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div> 
        <div (click)="selectSortByOption(sortByOptions.SLRN_DESC)" class="dropdown-option">
          <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.26407e-06 11.7457L1.4175 10.3348L4.6724 13.6051L4.68611 -8.20879e-06L6.68611 0.00199087L6.6725 13.5699L9.90275 10.3547L11.3136 11.7722L5.6436 17.4158L5.26407e-06 11.7457Z" fill="#000000"/>
          </svg>
          <span>SLRN</span>
          <svg *ngIf="sortByValue === sortByOptions.SLRN_DESC" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div> 
      </ng-container>
      <div (click)="selectSortByOption(sortByOptions.ID_ASC)" class="dropdown-option">
        <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6569 5.96207L10.2394 7.373L6.9845 4.10273L6.9708 17.7078L4.9708 17.7058L4.9844 4.13793L1.75416 7.3531L0.343262 5.93559L6.0133 0.291992L11.6569 5.96207Z" fill="#000000"/>
        </svg>
        <span>Id</span>
        <svg *ngIf="sortByValue === sortByOptions.ID_ASC" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div> 
      <div (click)="selectSortByOption(sortByOptions.ID_DESC)" class="dropdown-option">
        <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.26407e-06 11.7457L1.4175 10.3348L4.6724 13.6051L4.68611 -8.20879e-06L6.68611 0.00199087L6.6725 13.5699L9.90275 10.3547L11.3136 11.7722L5.6436 17.4158L5.26407e-06 11.7457Z" fill="#000000"/>
        </svg>
        <span>Id</span>
        <svg *ngIf="sortByValue === sortByOptions.ID_DESC" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div> 
    </div>
  </div>

  <button class="dropdown-btn" (click)="onAddDynamicFilter()">    
    <span class="add-dynamic-filters">{{ 'Add Dynamic Filters' | translate}}</span>
    <img src="../../../assets/icons/ng_v3/dropdown-icon.svg" alt="Dropdown" />
  </button>

  <button class="icon-btn">
    <img src="../../../assets/icons/ng_v3/filter-icon.svg" alt="Filters" />
  </button>
</div>